import { ConnectedBrokerageSelectSearchContainer } from './BrokerageSelectSearchContainer'

export default ConnectedBrokerageSelectSearchContainer
